import { NewUser } from './../../model/newUser';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ApiEndpoints, Grades, CookieNames, BasicRoutes, PaymentSteps } from './../../constant';
import { ShoppingCartService, HttpClientService, CookieManagerService, ErrorManagerService, RegistrationFeeService,RegistrationFeeTokenService, CustomObserverService } from '../../../shared';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { User } from '../../model/index';
import swal from 'sweetalert2';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-registration-paymennt',
  templateUrl: './registration-paymennt.component.html',
  styleUrls: ['./registration-paymennt.component.css', '../../../css/payment.component.css', '../../../css/paper-sets.component.css', '../../../css/login-selection.component.css'],
})
export class RegistrationPaymenntComponent implements OnInit {

  public isRegistration: boolean = true;
  public registrationFee: any = false;
  public registrationFeeAvailable: boolean = false;
  public registrationFeeToken: string;
  public isExpired: boolean = true;
  public isMobile: boolean = false;
  public rediectionUrl: string = BasicRoutes.clientExams;
  constructor(
    private router: Router,
    private registrationFeeService: RegistrationFeeService,
    private registrationFeeTokenService: RegistrationFeeTokenService,
    private route: ActivatedRoute,
    private customObserverService: CustomObserverService,
    private httpClientService: HttpClientService,
    private sanitizer: DomSanitizer
  ) {    
    this.customObserverService.setRegistrationFee(false);
    this.customObserverService.setPaymentCode(true);
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.route.params.subscribe(params => {
      if (params['token']) {
        this.registrationFeeService.setRegistrationTokenForFee(params['token']);
        this.isMobile = true;
        this.rediectionUrl = ApiEndpoints.MOBILE_REDIRECT_URL;
      }
    });
      this.getRegistrationPrice((callback) => {
          console.log();
      });
  }

  goBackUrl(url){
    if(url.startsWith('grade5://'))
      window.open(url);
    else
      window.location.href = url;
  };

  /**
   * get registration price
   * @param callback 
   */
  getRegistrationPrice(callback) {
    if (this.registrationFeeService.getRegistrationTokenForFee()) {
      this.httpClientService.authGet(ApiEndpoints.replaceParms(ApiEndpoints.getRegistrationFeeGForUser, { [ApiEndpoints.registrationToken]: this.registrationFeeService.getRegistrationTokenForFee() }), null).subscribe(
        res => {
          this.registrationFee = res['registerFee'];
          if( res['token'] != null){
            this.registrationFeeTokenService.setRegistrationToken(res['token']);
          }
          if (this.registrationFee) {
            this.registrationFeeAvailable = true;
             callback(this.registrationFeeAvailable,this.registrationFee);
          }else{
             callback(this.registrationFeeAvailable,this.registrationFee);
          }         
        }, e => {
          callback(this.registrationFeeAvailable,this.registrationFee);
           this.isExpired = false;
        });
    }else{
      callback(this.registrationFeeAvailable,this.registrationFee);
       this.isExpired = false;
    }
  }

  /**
   * get the registration details
   */
  getRegistrationDetails(callback) {
    // to check this page loaded from mobile or not
    this.route.params.subscribe(params => {
      if (params['token']) {
        this.registrationFeeService.setRegistrationTokenForFee(params['token']);
        this.isMobile = true;
        this.rediectionUrl = ApiEndpoints.MOBILE_REDIRECT_URL;
      }
    });
  }
  /**
   * get registration fee token
   */
  // getRegistrationFeeToken() {
  //   this.route.params.subscribe(params => {
  //     this.registrationFeeToken = (params['token'] || false) ? params['token'] : this.registrationFeeService.getRegistrationTokenForFee();
  //     if (this.registrationFeeToken != null) {
  //       this.registrationFeeService.setRegistrationTokenForFee(this.registrationFeeToken);
  //     }
  //   });
  // }
}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/registration/registration-paymennt/registration-paymennt.component.ts